import * as React from 'reactn';
import moment from "moment";
import IconButton from '@mui/material/IconButton';
import Clear from '@mui/icons-material/Clear';
import {
    ArrayUtil,
    Notification,
    base,
    IBaseProps, BaseColor, Route, SelectItem, LocalCache, DialogUtil, ComponentFactory
} from "oca-lib-web";
import analyticsLogo from "../image/analytics_logo_large.png";
import Constants from "../util/Constants";
import Sidebar from "../component/Sidebar";
import {createRef} from "react";
import {CircularProgress} from "@mui/material";
import Styles from "../style/Styles";
import VisualUtil from "../util/VisualUtil";

interface IState {
    componentFactory:ComponentFactory,
    rows: Array<NotificationHistoryModel>,
    selectedProject?: ProjectModel,
    projectOptions: Array<SelectItem>,
    //currentUser?: UserModel,
}

class MessagingPage extends React.PureComponent<IBaseProps, IState> {

    public alertDialog = createRef<any>();

    constructor(props: any) {
        super();

        let componentFactory = new ComponentFactory(Styles.default);
        componentFactory.addDefaultBinding(null, null, null);
        componentFactory.setHandleUpdateCallback(this.propertyChanged.bind(this));

        this.state = {
            componentFactory: componentFactory,
            rows: [],
            projectOptions: []
        };
    }

    async componentDidMount() {
        this.loadUser();
        var projectId = LocalCache.getLocal(Constants.CACHE_PROJECT_ID);
        if (!projectId) {
            //let projects = await this.global.data.getProjectsForCurrentUser();
            let projects = await this.global.dataManager.get("getProjectsForCurrentUser");
            ArrayUtil.sort(projects, "projectName");
            projectId = projects.length > 0 ? projects[0].id : null;
        }
        if (projectId) {
            //LocalCache.removeLocal(projectId + "_" + Constants.CACHE_ANALYTICS_SETTINGS);
            //this.loadProject(projectId);
            this.loadMessages(projectId);
        }
        //this.loadMessages();
    }

    async loadUser() {
        //let currentUser = await DataAccess.getCurrentUser();
        //let projects = await this.global.data.getProjectsForAdmin();
        let projects = await this.global.dataManager.get("getProjectsForAdmin");
        ArrayUtil.sort(projects, "projectName");
        let projectOptions = SelectItem.fromArray(projects, "id", "projectName");
        //console.log("Current user: " + JSON.stringify(currentUser));
        this.setState({projectOptions:projectOptions});
    }

    propertyChanged(value:any, key:string) {
        console.log("key: " + key + " value: " + value);
        if (key == "selectedProjectId") {
            this.onProjectSelected(value);
        }
    }

    onProjectSelected(value:any) {
        LocalCache.saveLocal(Constants.CACHE_PROJECT_ID, value);
        this.loadMessages(value);
    }

    async loadMessages(projectId:string) {
        console.log("Loading push notification history for : " + projectId);
        let project = await this.global.dataManager.get("getProject", projectId);
        //let project = await this.global.data.getProject(projectId);
        let messages = await this.global.dataManager.get("getNotificationHistory", projectId);
        //let messages = await this.global.data.getNotificationHistory(projectId);
        ArrayUtil.sort(messages, "date", true);
        console.log(messages);
        //messages = ArrayUtils.getItems(messages, "projectId", projectId);

        /*var openedMessages = [];
        for (let message of messages) {
            //let openedMessageList = await DataAccess.getNotificationsByMessageId(message.id);
            openedMessages.push({id:message.id, numberOpened:openedMessageList.length});
        }*/
        //var openedMessages = {id:message.id, numberOpened:messages.length};

        this.state.componentFactory.getDefaultBinding().setProperty("selectedProjectId", projectId);
        this.forceUpdate();

        this.setState({rows: messages, selectedProject: project});
    }

    /*getNotificationsForMessage(message:MessageModel):Array<any> {
        var messageList:Array<any> = [];
        var messages = DataAccess.getMessages();
        for (let message of messages) {

        }
    }*/

    getMessageRow(item: NotificationHistoryModel) {
        const dateStartedText = moment(item.date).format('MMMM D, YYYY h:mma');

        let actionLink = !item.completed ? <div>
            <IconButton onClick={DialogUtil.openFunction(this.alertDialog.current, item)}><Clear color='primary'/></IconButton>
        </div> : null;

        //let numberOpened = 0;
        /*for (let openedMessage of this.state.openedMessages) {
            if (openedMessage.id == item.id) {
                numberOpened = openedMessage.numberOpened;
            }
        }*/

        /*return [
            item.pushNotificationBody,
            item.completed || item.pushNotificationDate === "null" ? dateStartedText :
                "Scheduled for " + moment(item.pushNotificationDate).format("MMMM D, YYYY hh:mm a"),
            item.completed ? item.numberOfDevices : "",
            <div>{(numberOpened / item.numberOfDevices) + "%"}</div>,
            <div>{actionLink}</div>
        ];*/
        return [
            item.pushNotificationBody,
            !item.completed && item.pushNotificationDate != null ? "Scheduled for " + moment(item.pushNotificationDate).format("MMMM D, YYYY") + " " + moment(item.pushNotificationTime, "HHmm").format("hh:mm a")
                : dateStartedText,
            item.completed ? item.numberOfDevices : item.pushNotificationDate == null ?
                <span><CircularProgress style={{width:'25px', height:'25px', marginRight:'10px'}}/> Running</span> : "",
            item.completed ? this.calculateOpenRate(item) : "",
            <div>{actionLink}</div>
        ];
    }

    calculateOpenRate(item: NotificationHistoryModel) {
        return item.numberOfDevices == 0 ? "0%" : Math.round((item.numberOpened / item.numberOfDevices) * 100) + "%";
        //return "0%";
    }

    /*getAppMessageRow(item: AppMessageModel) {
            return [
                item.message,
                item.startDate,
                item.endDate
            ]
    }*/

    async deleteNotificationHistoryTapped(item:any) {
        await this.global.dataManager.delete("deleteNotificationHistory", item);
        this.loadMessages(this.state.selectedProject.id)
    }

    async dialogCallback(item: any) {
        Notification.success("Your push notification message has been sent. Please refresh this page to see the results");
    }

    /*renderHeader() {
        let cf = this.state.componentFactory;
        return (
            <div className="styledHeader" style={{backgroundColor:BaseColor.MAIN_BACKGROUND}}>
                { cf.renderBoxPadded(
                    <SelectComponent style={{width:'200px', backgroundColor:'#D7D7D7'}}
                                     disableUnderline={true}
                                     value={this.state.selectedProject ? this.state.selectedProject.id : ""}
                                     options={this.state.projectOptions}
                                     onChange={this.onProjectSelected.bind(this)} />
                ) }
            </div>
        );
    }*/

    render() {
        let cf = this.state.componentFactory;
        //let headerRowContentNotification = <ButtonComponent primary={true} title="New Notification" onTouchTap={Route.goFunction(this, "sendNotification/" + (this.state.selectedProject ? this.state.selectedProject.id : null))} />;
        let rightHandContent = cf.renderButton("New Notification", Route.goFunction(this, "sendNotification/" + this.state.selectedProject?.id));
        let leftHandContent = cf.renderSelectField("selectedProjectId", null, this.state.projectOptions, null, null, {inputType:"bootstrap"});
        let pushNotificationHeaders = ["Message", "Date Sent", "Number of Devices Sent", "Open Rate", ""];

        return (
            cf.renderBoxProps({fullHeight:true, background:BaseColor.WHITE},
                cf.renderBoxProps({marginLeft:'70px'}, [
                    VisualUtil.getHeaderDisplay("Notifications", rightHandContent),
                    cf.renderLine(),
                    VisualUtil.renderActionBar(leftHandContent),
                    this.state.selectedProject ?
                        cf.renderTable(pushNotificationHeaders, this.state.rows, this.getMessageRow.bind(this))
                        :
                        <div className="center-div-contents">
                            <img src={analyticsLogo} style={{marginTop:'100px', width:'50px'}} />
                            <div>No project set</div>
                        </div>
                ])
            )
        )
    }
}

export default base(MessagingPage, Sidebar)